<div class="p-20">
  <app-card padding="10" [showHeader]="false">
    <div class="row">
      <div class="col-12 col-md-12">
        <div class="grid">
          <button
            mat-flat-button color="primary"
            class="mat-body f-w-500"
            [disabled]="isSubmitting"
            (click)="onSubmit()"
          >
            @if (isSubmitting) {
              {{ 'Guardando ...' }}
            } @else {
              {{ 'Guardar' }}
            }
          </button>
        </div>
      </div>
    </div>
  </app-card>

  <app-clipboard-pane namespace="hardware.commands" [(value)]="valueRecord"/>

  @for (command of valueRecord; track command.key) {
    <app-card [showHeader]="false" padding="10">

      <div>
        <label>
          {{ (commands | findOfArray: { value: command.key })?.label?.['es'] || (commands | findOfArray: { value: command.key })?.label?.['default'] }}
        </label>
      </div>

      <br />

      @for (channel of command.channels; track channel) {

        <app-card [showHeader]="false" padding="10" [style.opacity]="channel.enable ? 1: 0.4">
          <div>
            <mat-slide-toggle
              color="success"
              [checked]="channel.enable"
              (change)="channel.enable = !channel.enable"
            >
              <label>Comando por {{ channel.key }} &nbsp;&nbsp;</label>
            </mat-slide-toggle>

            @if (channel.enable) {
              <mat-slide-toggle
                color="success"
                [checked]="channel.isCustom"
                (change)="channel.isCustom = !channel.isCustom"
              >
                <label> Personalizar</label>
              </mat-slide-toggle>
            }

          </div>


          @if (channel.isCustom) {
            <br />

            <app-field-code
              [value]="channel.custom"
              [options]="options"
              (valueChange)="channel.custom = $event"
            />
          }

        </app-card>
      }

    </app-card>
  }

</div>

